import { render, staticRenderFns } from "./AddStockTakeShipmentGovtModal.vue?vue&type=template&id=2fd5bd53&"
import script from "./AddStockTakeShipmentGovtModal.vue?vue&type=script&lang=js&"
export * from "./AddStockTakeShipmentGovtModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports